export const LOGO_URL = "https://customer-assets.emergentagent.com/job_doorstep-clean-4/artifacts/7vbfg7ed_Blitzwash_logo%20high%20res.png";
export const STORE_VIDEO_URL = "https://customer-assets.emergentagent.com/job_doorstep-clean-4/artifacts/qgtvl4ek_Store%20Inside%20Video.mp4";
export const WHATSAPP_URL = "https://wa.me/916367315665?text=Hi%20Blitzwash%2C%20I%20want%20to%20book%20free%20laundry%20pickup";
export const PHONE = "+91 63673 15665";
export const EMAIL = "blitzwashlaundry@gmail.com";
export const INSTAGRAM = "https://www.instagram.com/blitzwashlaundry/";

// ---- Trust & recognition ----
export const DPIIT = {
  number: "DIPP261608",
  label: "DPIIT Recognized Startup",
  fullLabel: "Recognized by Startup India · Government of India",
  logoUrl: "https://www.startupindia.gov.in/content/dam/invest-india/logo/StartupIndia_Logo.png",
};

// ---- Promo banner ----
export const PROMO = {
  active: true,
  code: "BLITZ20",
  headline: "First order 20% OFF",
  subline: "Use code BLITZ20 · Free pickup & delivery across Jaipur",
};

// ---- Founders ----
export const FOUNDERS = [
  {
    name: "Keshav Parwal",
    role: "Co-Founder",
    creds: "CA · IIM Kozhikode",
    previously: "Ex-Private Equity, Deloitte",
    linkedin: "https://www.linkedin.com/in/keshav-parwal/",
    initials: "KP",
  },
  {
    name: "Varnit Mehta",
    role: "Co-Founder",
    creds: "CA · IIM Kozhikode",
    previously: "Ex-Consultant",
    linkedin: "https://www.linkedin.com/in/varnitmehta/",
    initials: "VM",
  },
];

export const MISSION = {
  headline: "Organizing India's ₹2 lakh crore laundry industry — one wash at a time.",
  body: "Laundry in India is still stuck in the 1990s. Manual notebooks, endless follow-ups, unpredictable turnaround, and inconsistent quality. We're building India's quick-commerce laundry and dry-cleaning app so you can book a pickup with just a few taps — and get consistently spotless clothes delivered back in 24 hours. Our mission is to reduce inefficiencies in the fragmented Indian laundry system and set a new bar for reliability, hygiene, and speed.",
};

// ---- Customer app ----
export const APP_COMING_SOON = {
  iosLive: false,
  androidLive: false,
  headline: "Blitzwash App — Coming Soon",
  subline: "Book pickups, track your order live, and pay in one tap. Launching on iOS and Android soon.",
};

// ---- Service areas (Jaipur) ----
export const SERVICE_AREAS = [
  "Nirman Nagar", "Vaishali Nagar", "Rangoli Garden", "Chordiya City",
  "Amrapali Inn", "Gandhi Path", "Vaishali Enclave", "Chitrakoot",
  "Ajmer Road", "Sirsi Road", "New Sanganer Road", "Patrakar Colony",
  "Kailash Puri", "Rangoli Garden Society", "Ridhi Sidhi Chauraha",
  "Nirman Nagar Extension", "Vaishali Marg", "Manyawas", "Shipra Path",
];

// ---- Comparison table ----
export const COMPARISON = {
  headline: "Why Blitzwash beats local & franchise laundries",
  columns: ["Feature", "Blitzwash", "Local Laundry", "Franchise Chain"],
  rows: [
    { feature: "24-hour turnaround", blitzwash: "yes", local: "no", franchise: "sometimes" },
    { feature: "Free doorstep pickup & delivery", blitzwash: "yes", local: "sometimes", franchise: "yes" },
    { feature: "Transparent per-item pricing", blitzwash: "yes", local: "no", franchise: "yes" },
    { feature: "Eco-friendly detergents", blitzwash: "yes", local: "no", franchise: "sometimes" },
    { feature: "Trained staff & SOPs", blitzwash: "yes", local: "no", franchise: "yes" },
    { feature: "Damage protection", blitzwash: "yes", local: "no", franchise: "sometimes" },
    { feature: "Multiple stores in Jaipur", blitzwash: "yes", local: "no", franchise: "yes" },
    { feature: "Backed by IIM alumni + DPIIT", blitzwash: "yes", local: "no", franchise: "no" },
    { feature: "Prices start at ₹60/kg", blitzwash: "yes", local: "sometimes", franchise: "no" },
  ],
};

// ---- Photo gallery (real + AI-generated Indian clothing) ----
export const GALLERY_IMAGES = [
  { url: "/images/gen/hero_1.png", alt: "Freshly cleaned Indian silk sarees stacked on wooden shelf" },
  { url: "/images/gen/kurta_pyjama.png", alt: "Freshly pressed men's kurta pyjama on hangers" },
  { url: "/images/gen/sherwani.png", alt: "Wedding sherwani after professional dry cleaning" },
  { url: "/images/gen/lehenga.png", alt: "Bridal lehenga carefully hung after dry cleaning" },
  { url: "/images/gen/shirts_hanging.png", alt: "Row of freshly pressed office shirts" },
  { url: "/images/gen/wash_fold.png", alt: "Neatly folded Indian family laundry" },
  { url: "/images/gen/ironing.png", alt: "Blitzwash professional steam-ironing a kurta" },
  { url: "/images/gen/saree_folded.png", alt: "Elegantly folded banarasi silk saree" },
  { url: "/images/gen/basket.png", alt: "Wicker basket full of clean folded family clothes" },
  { url: "/images/gen/delivery.png", alt: "Blitzwash doorstep delivery in Jaipur" },
  { url: "/images/gen/machines.png", alt: "Commercial washing machines at our Jaipur facility" },
  { url: "/images/gen/towels.png", alt: "Fluffy freshly washed towels" },
];

// ---- Nav (updated to include page links) ----
export const navLinks = [
  { label: "Home", href: "/" },
  { label: "Services", href: "/#services", isDropdown: true, children: [
    { label: "Wash & Fold", href: "/services/wash-fold" },
    { label: "Wash & Steam Iron", href: "/services/steam-iron" },
    { label: "Dry Cleaning", href: "/services/dry-cleaning" },
    { label: "Premium Laundry", href: "/services/premium-laundry" },
    { label: "Shoe Cleaning", href: "/services/shoe-care" },
  ]},
  { label: "Pricing", href: "/pricing" },
  { label: "About", href: "/about" },
  { label: "Corporate", href: "/corporate" },
  { label: "Blog", href: "/blog" },
];

export const heroData = {
  headline: "Fresh Clothes.\nDelivered in 24 Hours.",
  subheadline: "Jaipur's fastest doorstep laundry service. We pick up, clean with care, and deliver back \u2014 because your clothes belong to you, not the laundry shop.",
  ctaPrimary: "Schedule Free Pickup",
  ctaSecondary: "View Pricing",
  badgeText: "24-Hour Turnaround Guarantee",
};

export const stats = [
  { value: "10,000+", label: "Orders Delivered", numeric: 10000, suffix: "+" },
  { value: "5,000+", label: "Happy Customers", numeric: 5000, suffix: "+" },
  { value: "24hrs", label: "Avg. Turnaround", numeric: 24, suffix: "hrs" },
  { value: "4.9", label: "Google Rating", numeric: 4.9, decimals: 1, isStar: true },
];

export const services = [
  { id: 1, title: "Dry Cleaning", description: "Premium solvent-based cleaning for delicate fabrics, designer wear, suits, sarees, lehengas, and special garments. Expert stain removal with professional finish.", iconKey: "sparkles", priceLabel: "Starting \u20B969", features: ["Stain Removal", "Color Protection", "Premium Finish", "48hr Delivery"], slug: "dry-cleaning" },
  { id: 2, title: "Laundry", description: "Everyday laundry washed with premium detergents. Choose Wash & Fold or Wash & Steam Iron. Fresh, soft, and perfectly pressed clothes ready to wear.", iconKey: "shirt", priceLabel: "Starting \u20B960/kg", features: ["Wash & Fold", "Wash & Steam Iron", "Woolen Care", "24hr Delivery"], slug: "wash-fold" },
  { id: 3, title: "Shoe Cleaning", description: "Professional shoe restoration and deep cleaning for sports shoes, sneakers, leather, suede, and boots. Your favourite shoes will look brand new again.", iconKey: "footprints", priceLabel: "Starting \u20B9249", features: ["Deep Cleaning", "Stain Treatment", "All Shoe Types", "Expert Care"], slug: "shoe-care" },
];

export const howItWorksSteps = [
  { step: 1, title: "Schedule Pickup", description: "Book in 30 seconds. Call, WhatsApp, or use our website — choose a time that works for you.", iconKey: "calendarClock" },
  { step: 2, title: "We Collect", description: "Our delivery partner arrives at your doorstep in Jaipur. Free pickup with no minimum order.", iconKey: "truck" },
  { step: 3, title: "Expert Care", description: "Your garments are cleaned with premium eco-friendly detergents by trained professionals.", iconKey: "sparkles" },
  { step: 4, title: "Swift Delivery", description: "Fresh, clean clothes delivered back within 24 hours. That's the Blitzwash promise.", iconKey: "zap" },
];

export const whyChooseUs = [
  { title: "24-Hour Turnaround", description: "Jaipur's fastest laundry service. Your clothes are cleaned, pressed, and delivered within a day.", iconKey: "zap" },
  { title: "Free Pickup & Delivery", description: "No hidden charges. We come to your door, pick up, and deliver back — completely free.", iconKey: "truck" },
  { title: "Affordable Prices", description: "Premium quality at pocket-friendly rates. Great laundry shouldn't burn a hole in your pocket.", iconKey: "indianRupee" },
  { title: "Eco-Friendly Process", description: "We use biodegradable detergents that are tough on stains but gentle on your clothes and the planet.", iconKey: "leaf" },
  { title: "Professional Care", description: "Trained experts handle every garment with individual attention. Special care for delicates.", iconKey: "shieldCheck" },
  { title: "Easy Scheduling", description: "Book via website, WhatsApp, or call. Choose your preferred time for pickup and delivery.", iconKey: "calendarClock" },
];

export const stores = [
  { name: "Gandhi Path", area: "Gandhi Path, Jaipur", status: "open", phone: "+91 63673 15665", mapLink: "https://maps.app.goo.gl/j61pmpdBSuH25bvd9" },
  { name: "Nirman Nagar", area: "Nirman Nagar, Jaipur", status: "open", phone: "+91 95882 43141", mapLink: "https://maps.app.goo.gl/SgS6eEYsM9tWLe34A" },
  { name: "Malviya Nagar", area: "Malviya Nagar, Jaipur", status: "coming-soon" },
  { name: "Rajapark", area: "Rajapark, Jaipur", status: "coming-soon" },
  { name: "Mansarovar", area: "Mansarovar, Jaipur", status: "coming-soon" },
];

// pricingData / faqs / footerData / testimonials unchanged (fetched from backend at runtime via useContent)
export const pricingData = {};
export const testimonials = [];
export const faqs = [];
export const footerData = {
  description: "Jaipur's fastest doorstep laundry service. Fresh clothes delivered within 24 hours. Because your clothes belong to you.",
  services: ["Dry Cleaning", "Laundry", "Shoe Cleaning", "Steam Ironing", "Household Cleaning", "Bag Cleaning"],
  contact: { phone: "+91 63673 15665", email: "Blitzwashlaundry@gmail.com", address: "Jaipur, Rajasthan" },
};

// ---- Blog posts (static content for now) ----
export const BLOG_POSTS = [
  {
    slug: "best-laundry-service-in-jaipur",
    title: "The Best Laundry Service in Jaipur — What to Actually Look For",
    excerpt: "Jaipur has dozens of laundries. Here's the 6-point checklist locals use to separate reliable pros from the ones that ruin your favourite kurta.",
    category: "Buyer's Guide",
    date: "Jan 2026",
    readTime: "5 min read",
    image: "/images/gen/wash_fold.png",
    body: [
      "If you Google \"best laundry service in Jaipur,\" you'll find every service claiming to be #1. Here's what actually matters when your monsoon-soaked kurta is on the line.",
      "**1. Fixed per-item pricing.** If they weigh everything and charge by kg only, you'll be surprised at delivery. Real pros publish a per-item rate card for dry cleaning.",
      "**2. Same-fabric batching.** Whites should never wash with a red saree. Ask if they separate by colour and fabric — most Jaipur laundries don't.",
      "**3. Turnaround guarantee.** \"Kal mil jayega\" is not a guarantee. A real service gives you a 24-hour written window and honours it.",
      "**4. Free doorstep pickup + delivery.** No minimum order, no ₹50 add-on charge. This is the modern standard in Jaipur.",
      "**5. Damage protection.** If they wreck your ₹15,000 lehenga, do they compensate? Ask before, not after.",
      "**6. Transparent tracking.** WhatsApp updates when picked up, when in wash, when out for delivery. If they can't do this, they're not built for 2026.",
      "Blitzwash checks all 6. Free pickup anywhere in Jaipur, 24-hour delivery, per-item rate card, and WhatsApp updates at every stage. Book on WhatsApp to get 20% off with code BLITZ20.",
    ],
  },
  {
    slug: "laundry-service-in-vaishali-nagar-jaipur",
    title: "Laundry Service in Vaishali Nagar, Jaipur — Doorstep Pickup Guide",
    excerpt: "Vaishali Nagar residents used to depend on the local dhobi. Here's why 500+ Vaishali Nagar families switched to Blitzwash in 2025.",
    category: "Service Area",
    date: "Jan 2026",
    readTime: "4 min read",
    image: "/images/gen/delivery.png",
    body: [
      "Vaishali Nagar is one of Jaipur's most densely populated residential pockets — apartments, standalone houses, PGs, and mixed-use plots all packed into a 3 km radius.",
      "For years, the only options here were: (1) the neighbourhood dhobi with unpredictable turnaround, or (2) driving 20 minutes to a chain outlet on MI Road.",
      "**Blitzwash pickup schedule for Vaishali Nagar:** Morning (7–10 AM), Afternoon (12–3 PM), Evening (5–8 PM). Every day, no minimum order.",
      "**Coverage inside Vaishali Nagar:** Sector 1, 2, 3, 4, 5, Vaishali Enclave, Vaishali Marg, Manyawas, Shipra Path, Ridhi Sidhi Chauraha — all included with free doorstep pickup and delivery.",
      "**Popular services in Vaishali Nagar:** Weekly Wash & Fold subscription (₹60/kg), Wash & Steam Iron for office wear (₹100/kg), and dry cleaning for wedding-season sarees & sherwanis.",
      "To book in Vaishali Nagar, WhatsApp us at +91 63673 15665 or use the estimator on our homepage — the pickup partner will reach you within 2 hours in most cases.",
    ],
  },
  {
    slug: "laundry-service-in-nirman-nagar-jaipur",
    title: "Laundry Service in Nirman Nagar, Jaipur — Now with a Dedicated Store",
    excerpt: "Nirman Nagar's newest Blitzwash store opens with a dedicated phone line (+91 95882 43141) and same-day service for regulars. Here's what's inside.",
    category: "Service Area",
    date: "Jan 2026",
    readTime: "3 min read",
    image: "/images/gen/machines.png",
    body: [
      "Our Nirman Nagar store — dedicated phone +91 95882 43141 — has become the go-to laundry for hundreds of families in the area. Here's what's inside.",
      "**Same-day laundry.** Drop your bag before 11 AM, get it back the same evening. Only available for our Nirman Nagar walk-ins.",
      "**Extra care unit for silks and delicates.** Sarees, dupattas, and wedding wear are handled in a separate low-agitation cycle to protect embroidery and colour.",
      "**Shoe cleaning bay.** Full separate wing for sports shoes, sneakers, leather, and suede. Take a look next time you drop off clothes.",
      "**Serving:** Nirman Nagar core, Nirman Nagar Extension, Kailash Puri, Chordiya City, Amrapali Inn Society, and Rangoli Garden Society — all with free doorstep pickup.",
      "Prefer WhatsApp? Message the Nirman Nagar store directly at wa.me/919588243141.",
    ],
  },
  {
    slug: "how-to-store-woolens-in-summer",
    title: "How to Store Woolens in Summer (India Edition) — Without Ruining Them",
    excerpt: "Moth-eaten sweaters, faded blazers, that faint musty smell in December. Here's the dry-cleaner's 4-step method to protect your wool through Indian summers.",
    category: "Garment Care",
    date: "Jan 2026",
    readTime: "4 min read",
    image: "/images/gen/sherwani.png",
    body: [
      "In Indian summers, humidity + heat + moths destroy more woolens than actual wear. Here's what we tell our customers every March.",
      "**Step 1 — Dry clean before storing.** Never store wool with a season's worth of body oils and sweat on it. Moths and mildew love the salts and proteins in sweat, not the wool itself.",
      "**Step 2 — Skip plastic bags.** Plastic traps humidity and creates the exact micro-climate mildew needs. Use breathable muslin cotton covers or cardboard boxes with airholes.",
      "**Step 3 — Cedar wood + neem leaves.** Chemical mothballs (paradichlorobenzene) leave a smell wool absorbs for months. Cedar chips and dried neem leaves work almost as well and don't stink.",
      "**Step 4 — Fold, don't hang.** Hanging stretches wool at the shoulders permanently. Fold, layer with tissue paper, and store on a shelf.",
      "**Bonus — Air out once a month.** On a dry, sunny day, pull everything out for 30 minutes of indirect sunlight. Kills any mildew starts. Blitzwash offers seasonal woolen storage cleaning — one bulk booking, everything comes back moth-proof for the summer.",
    ],
  },
  {
    slug: "dry-cleaning-vs-laundry-when-to-use-which",
    title: "Dry Cleaning vs Laundry — When Should You Use Which?",
    excerpt: "Dry cleaning is not \"premium laundry.\" It's a completely different process, and using it wrong wastes ₹300 or ruins a shirt. Here's the exact decision tree.",
    category: "Garment Care",
    date: "Jan 2026",
    readTime: "3 min read",
    image: "/images/gen/kurta_pyjama.png",
    body: [
      "Most customers use these interchangeably. Wrong choice = wasted money or a ruined garment.",
      "**Use LAUNDRY (water-based wash) for:** cotton, linen, polyester, denim, gym-wear, kids' clothes, bedsheets, towels. Anything that can safely see water.",
      "**Use DRY CLEANING (solvent-based) for:** silk, wool, rayon, sequined/embroidered wear, suits, sherwanis, sarees, lehengas, blazers, structured jackets, and anything with a \"dry clean only\" label.",
      "**Signals your garment needs dry cleaning:** the label says dry-clean-only, the fabric is silk/wool/rayon, there's zari/embroidery/beadwork, the garment is structured (jacket lining, suit shoulder pads).",
      "**One rule of thumb:** if in doubt, dry clean it once and see. Never machine-wash a labelled dry-clean-only garment. The first wash rarely destroys it — the third wash usually does.",
      "Blitzwash lets you split a single pickup: Wash & Fold for towels + Wash & Steam Iron for shirts + Dry Cleaning for that one silk kurta — all in one bag, all priced individually.",
    ],
  },
  {
    slug: "how-to-remove-oil-stains-from-clothes",
    title: "How to Remove Oil Stains from Clothes (Without Ruining Them)",
    excerpt: "The 4-step method our stain-removal experts use on every ghee, curry, and machine-oil stain — before it reaches the wash cycle.",
    category: "Stain Removal",
    date: "Jan 2026",
    readTime: "4 min read",
    image: "/images/gen/ironing.png",
    body: [
      "Oil is one of the trickiest stains because it repels water. Water-only wash will only spread it deeper into the fibres.",
      "**Step 1 — Blot, don't rub.** Use a paper towel to absorb as much oil as possible. Rubbing pushes oil deeper.",
      "**Step 2 — Cornstarch or talcum powder.** Sprinkle generously and let it sit for 15 minutes. It absorbs the oil.",
      "**Step 3 — Dish soap dab.** Rub a drop of dish soap into the stain and let it sit for 10 minutes. Dish soap is a degreaser.",
      "**Step 4 — Warm water rinse.** Rinse from the back of the fabric to push the oil out, not in.",
      "For old or heavy oil stains (like ghee or engine oil on jeans), it's better to give it to a professional — the stain has usually set and needs solvent-based dry cleaning.",
    ],
  },
  {
    slug: "how-often-should-you-dry-clean-suits",
    title: "How Often Should You Dry Clean Your Suits?",
    excerpt: "Too often ruins the fabric. Not often enough ruins the fit. Here's the sweet spot our tailors and dry-cleaners recommend.",
    category: "Garment Care",
    date: "Jan 2026",
    readTime: "3 min read",
    image: "/images/gen/lehenga.png",
    body: [
      "Dry cleaning too frequently strips the natural oils in wool and causes fibres to become brittle. Not enough, and body oils + sweat degrade the fabric silently.",
      "**Daily-wear suits:** every 3-4 wears, or once a season if worn occasionally.",
      "**Wedding sherwani or lehenga:** immediately after the event — spilled food, sweat, and makeup set fast.",
      "**Silk sarees:** only when visibly soiled. Store in muslin cloth, not plastic.",
      "Between dry cleans: brush with a garment brush after each wear, hang overnight to air out, and steam-iron lightly.",
    ],
  },
  {
    slug: "wash-and-fold-vs-wash-and-iron",
    title: "Wash & Fold vs Wash & Steam Iron — Which Should You Pick?",
    excerpt: "₹60/kg vs ₹100/kg. When it matters, when it doesn't, and how to save ₹800/month picking right.",
    category: "Pricing",
    date: "Jan 2026",
    readTime: "3 min read",
    image: "/images/gen/basket.png",
    body: [
      "**Wash & Fold (₹60/kg)** is best for towels, bedsheets, undergarments, gym clothes, kids' clothes, and anything that doesn't need to look pressed.",
      "**Wash & Steam Iron (₹100/kg)** is worth it for office shirts, kurtas, formal trousers, and anything you'd wear out.",
      "**The mix-and-match trick:** most Jaipur customers save ₹500-800/month by giving Wash & Fold for their weekend/home clothes and Wash & Steam Iron for weekday office wear — instead of picking one price for everything.",
      "Blitzwash lets you split a single pickup across both services. Just tell the delivery partner at pickup — no extra charge.",
    ],
  },
  {
    slug: "how-to-clean-white-sneakers",
    title: "How to Clean White Sneakers So They Look Brand New (Not Yellow)",
    excerpt: "The exact steps we follow at Blitzwash Shoe Cleaning to restore yellowed, dirty white sneakers — including the trick most people get wrong.",
    category: "Shoe Care",
    date: "Jan 2026",
    readTime: "4 min read",
    image: "/images/shoe-before-after.jpg",
    body: [
      "White sneakers yellow for three reasons: dirt oxidation, UV exposure, and detergent residue. Home cleaning usually only fixes the first one.",
      "**Step 1 — Remove laces + insoles.** Wash them separately. Laces get grey in the machine; insoles need hand-scrubbing.",
      "**Step 2 — Baking soda + hydrogen peroxide paste.** 1 tbsp baking soda + 1 tsp hydrogen peroxide. Scrub with an old toothbrush. This attacks the yellow oxidation directly.",
      "**Step 3 — Never machine-wash sneakers with mesh uppers.** The bounce damages the glue lining and unglues the sole within 2-3 washes.",
      "**Step 4 — Sun-dry ONLY when they're 90%+ dry.** Direct sun on wet sneakers is what causes yellowing in the first place. Air-dry indoors first, then quick sun finish.",
      "**Why hand it to a pro?** Because commercial shoe-cleaning uses an oxygen-based whitening solution (not chlorine bleach, which weakens fibres) that's not sold in stores. Blitzwash Shoe Cleaning restores yellowed whites for ₹249 — with free pickup.",
    ],
  },
  {
    slug: "wedding-lehenga-dry-cleaning-guide",
    title: "Wedding Lehenga Dry Cleaning — Complete Post-Function Guide",
    excerpt: "Your ₹40,000 lehenga has 3 days of makeup, mehendi, food, and sweat on it. Here's how NOT to ruin it before it goes to the dry cleaner.",
    category: "Garment Care",
    date: "Jan 2026",
    readTime: "5 min read",
    image: "/images/gen/lehenga.png",
    body: [
      "The 3 days after your function are when most lehengas get permanently damaged — usually by well-meaning family members doing the wrong thing.",
      "**Do NOT:** dab any stain with water, rub any area, hang it in sunlight to \"air out\", fold it while still humid, or spray perfume on it as a temporary fix. All five of these set stains permanently.",
      "**DO immediately:** hang it on a padded hanger inside a well-ventilated room (fan on, no direct sun), let it dry for 6 hours, then transport to a professional dry cleaner in a muslin cover (not plastic).",
      "**Common lehenga stains and their treatment:** foundation/makeup (needs solvent + gentle brush), turmeric/haldi (needs oxidation treatment — never bleach), red gulal (fast-set dye, needs immediate cold water on JUST the stain), oil/ghee (cornstarch first, then solvent).",
      "**At Blitzwash:** each wedding lehenga is hand-inspected before wash, embroidery is protected with muslin covers during the cycle, and delivery is on padded hangers inside cotton garment covers — not plastic. Book on WhatsApp for pickup within 2 hours of your function.",
    ],
  },
  {
    slug: "how-to-maintain-office-shirts",
    title: "How to Make Office Shirts Last 3x Longer (Without Ironing Every Day)",
    excerpt: "The 5-minute daily habit that keeps cotton shirts crisp for years, and the wash mistake most working professionals make every week.",
    category: "Garment Care",
    date: "Jan 2026",
    readTime: "3 min read",
    image: "/images/gen/shirts_hanging.png",
    body: [
      "The average cotton shirt is designed for 60-80 washes. Most professionals get 25-30 washes out of it before the collar frays. Here's why.",
      "**Mistake 1 — Washing after every wear.** Cotton wears from friction, not from dirt. Unless it's visibly stained or smells, cotton shirts can go 2-3 wears before wash.",
      "**Mistake 2 — Hanging while wet.** Wet cotton stretches at the shoulders permanently. Always fold-dry flat first, then hang.",
      "**Mistake 3 — Ironing at max temperature.** High heat glazes cotton fibres and gives that plasticky look. Medium heat + steam does the same job without damage.",
      "**Mistake 4 — Wire hangers.** They stretch shoulders and leave rust marks. Use wooden or padded hangers only.",
      "**Best routine for office shirts:** Weekly Wash & Steam Iron with Blitzwash (₹100/kg — comes back hanger-ready, no ironing at home). Add a Sunday-morning inspection: turn collars inside out, apply a paste of baking soda + water on any collar stains for 10 min before drop-off.",
    ],
  },
];

// ---- Service pages meta (used by /services/:slug) ----
export const SERVICE_PAGES = {
  "wash-fold": {
    title: "Wash & Fold Laundry in Jaipur",
    subtitle: "Everyday laundry, professionally washed, dried, and folded — from ₹60/kg.",
    price: "₹60/kg",
    turnaround: "24 hours",
    iconKey: "shirt",
    image: "/images/gen/wash_fold.png",
    highlights: ["Premium eco-friendly detergents", "Fabric-separated cycles", "Machine dried", "Neatly folded", "24-hour turnaround", "Free pickup & delivery"],
    idealFor: ["Bedsheets & towels", "Everyday casual clothes", "Kids clothes", "Gym & sportswear", "Bulk family laundry"],
    process: [
      { step: "Sort", text: "Whites, colours, and delicates separated." },
      { step: "Wash", text: "Premium detergent + fabric softener in commercial-grade machines." },
      { step: "Dry", text: "Temperature-controlled tumble dry — no shrinkage." },
      { step: "Fold", text: "Precision folded and packed by garment type." },
    ],
  },
  "steam-iron": {
    title: "Wash & Steam Iron in Jaipur",
    subtitle: "Washed, steam-pressed, hanger-ready — from ₹100/kg.",
    price: "₹100/kg",
    turnaround: "24 hours",
    iconKey: "sparkles",
    image: "/images/gen/ironing.png",
    highlights: ["Steam-finished ironing", "Crease protection", "Hanger-ready delivery", "Premium garment care", "24-hour turnaround", "Free pickup & delivery"],
    idealFor: ["Office shirts & trousers", "Kurtas & pyjamas", "Formal wear", "Everyday work clothes"],
    process: [
      { step: "Wash", text: "Fabric-specific wash cycle with premium detergents." },
      { step: "Dry", text: "Controlled temperature dry to prevent shrinkage." },
      { step: "Steam Iron", text: "Steam-pressed at optimal temperature for every fabric." },
      { step: "Hang & Pack", text: "Hanger-ready, wrapped, and delivered wrinkle-free." },
    ],
  },
  "dry-cleaning": {
    title: "Dry Cleaning in Jaipur",
    subtitle: "Solvent-based professional cleaning for delicate & designer garments — from ₹69.",
    price: "₹69 per garment",
    turnaround: "48 hours",
    iconKey: "shieldCheck",
    image: "/images/gen/sherwani.png",
    highlights: ["Delicate fabric protocol", "Stain-specific pre-treatment", "Colour retention process", "Luxury finish", "Silk, wool, sherwani, lehenga safe", "48-hour delivery"],
    idealFor: ["Wedding wear (sherwani, lehenga)", "Silk sarees & dupattas", "Woollen suits & blazers", "Designer wear", "Curtains & upholstery"],
    process: [
      { step: "Inspect", text: "Every garment inspected for stains, damage, embellishments." },
      { step: "Pre-treat", text: "Stain-specific solvents applied before main cycle." },
      { step: "Dry Clean", text: "Solvent-based cleaning in temperature-controlled machines." },
      { step: "Finish", text: "Hand-pressed, packed on hangers, ready to wear." },
    ],
  },
  "premium-laundry": {
    title: "Premium Laundry in Jaipur",
    subtitle: "White-glove treatment for your best clothes — separate wash, softener, individual finish. ₹160/kg.",
    price: "₹160/kg",
    turnaround: "24-48 hours",
    iconKey: "star",
    image: "/images/gen/lehenga.png",
    highlights: ["Individual bag wash — no mixing", "Fabric softener + brightening rinse", "Hand-inspected finishing", "Hanger-ready or folded", "Priority processing", "Same-day option available"],
    idealFor: ["High-value office wear", "New clothes needing extra care", "Colour-critical garments", "Household with sensitive skin", "Whites & pastels"],
    process: [
      { step: "Individual Bag", text: "Your clothes never mix with others' — separate machine cycle." },
      { step: "Premium Wash", text: "Enzyme detergent + brightening rinse + softener." },
      { step: "Air Assist Dry", text: "Gentler drying preserves fibre integrity." },
      { step: "Hand Finish", text: "Individual inspection, pressing, and packing." },
    ],
  },
  "shoe-care": {
    title: "Shoe Cleaning in Jaipur",
    subtitle: "Sports shoes, sneakers, leather, suede — deep cleaned & restored. From ₹249.",
    price: "₹249",
    turnaround: "4-5 days",
    iconKey: "footprints",
    image: "/images/shoe-before-after.jpg",
    highlights: ["Material-aware cleaning process", "Odour neutralization", "Sole restoration", "Protective conditioning", "Safe for suede & leather", "Free pickup"],
    idealFor: ["White sneakers gone yellow", "Muddy sports shoes", "Leather formal shoes", "Suede boots", "Everyday walking shoes"],
    process: [
      { step: "Inspect", text: "Material identified — suede, leather, canvas, mesh get different treatments." },
      { step: "Deep Clean", text: "Interior + exterior cleaned. Laces washed separately." },
      { step: "Deodorize", text: "Anti-microbial spray for odour neutralization." },
      { step: "Condition", text: "Leather conditioned, suede brushed, protective spray applied." },
    ],
  },
};
